
















































































































































































































































































import mixins from 'vue-typed-mixins';
import BoxContainer from "@/components/BoxContainer.vue";
import { AmendmentViewModel } from "@/models/AmendmentViewModel";
import { required , numeric , maxLength } from 'vuelidate/lib/validators';
import vuelidateMixin from "@/mixins/vuelidateMixin";
import { WorkAreaViewModel } from "@/models/WorkAreaViewModel";

export default mixins( vuelidateMixin ).extend( {
  name: "AmendmentForm",
  components: {
    BoxContainer,
  },
  props: {
    value: {
      type: Object as () => AmendmentViewModel
    },
    formSaving: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'new'
    },
    workAreaList: {
      type: Array as () => WorkAreaViewModel[],
      default: null
    }
  },
  data(): {
    amendment: AmendmentViewModel
    itemId: number
    landUsesList: any[]
  }{
    return {
      amendment: { ...this.value } as AmendmentViewModel,
      itemId: 0 ,
      landUsesList: [],
    }
  },
  validations: {
    amendment: {
      workAreaAbbreviation: {
        required
      },
      locatedAt:{
        required,
        maxLength: maxLength(2000)
      },
      isInContainmentBoundary: {
        required
      },
      isInLandReserve: {
        required
      },
      metroLandUseDesignation: {
        required
      },
      extensionRationale: {
        required,
        maxLength: maxLength(5000)
      },
      existingADWF: {
        required,
        numeric
      },
      existingPWWF: {
        required,
        numeric
      },
      propertyId: {
        required,
        maxLength: maxLength(50)
      },
      comments: {
        maxLength: maxLength(2000)
      }
    }
  },
  computed: {
    workAreaListSelect(): any[] {

      const workAreaList = [];
      workAreaList.push( { "header" : "Sewerage Areas" } );
      for ( let i = 0; i < this.workAreaList.length; i++ ) {
        if ( this.workAreaList[i].category === 'SA') {
          workAreaList.push( this.workAreaList[i]);
        }
      }
      workAreaList.push( { "header" : "Drainage Areas" } );
      for ( let x = 0; x < this.workAreaList.length; x++ ) {
        if ( this.workAreaList[x].category === 'DA') {
          workAreaList.push( this.workAreaList[x] );
        }
      }
      return workAreaList;
    },
  } ,
  methods: {
    triggerValidation() {
      const valid = this.isValidWithNotification(this.$v.amendment);

      if ( valid ) {
        this.$emit('click');
      }
    },
    async getLandUses() {
      const results = await this.axios.get('/Lookups/GetLandUses');
      this.landUsesList = results.data;
    },
  },
  mounted() {
    this.getLandUses();
    if (this.mode === 'new') {
      //this.amendment = this.value;
    }
  },
  watch: {
    value: {
      handler() {
        this.amendment = { ...this.value }
      },
      deep: true ,
      immediate: true
    },

  },
} )

